module.exports = __webpack_public_path__ + "static/media/HCMM676.569dccdd.jpg";